var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
import { obterVeiculos } from "../../services/veiculos.service";
import { veiculoStore } from "../../stores/VeiculoStore";
import { Colors } from "../../util/theme";
export var InfoVeiculo = function (_a) {
    var defineVehicle = _a.defineVehicle;
    var userInfo = useAuth().userInfo;
    var placa = useParams().placa;
    var _b = veiculoStore(), veiculo = _b.veiculo, setVeiculo = _b.setVeiculo;
    var _c = useState(), veiculoSelecionado = _c[0], setVeiculoSelecionado = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        var fetchVeiculos = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, veiculo_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                            pagina: "1",
                        };
                        return [4 /*yield*/, obterVeiculos(payload)];
                    case 1:
                        response = _a.sent();
                        veiculo_1 = response.find(function (item) { return item.placa.trim() === placa; });
                        if (veiculo_1) {
                            setVeiculoSelecionado(veiculo_1);
                            setVeiculo(veiculo_1);
                            defineVehicle && defineVehicle(veiculo_1);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchVeiculos();
    }, [placa, userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username]);
    if (!veiculo && loading) {
        return _jsx(Skeleton, { variant: "rectangular", width: "100%", height: "9rem" });
    }
    return (_jsxs(Stack, __assign({ flexDirection: "column", alignItems: "start", gap: "1rem", padding: "1rem", mb: "1rem", sx: { backgroundColor: "white" } }, { children: [_jsx(Typography, __assign({ variant: "body1", fontSize: "1.375rem", fontWeight: "500" }, { children: (veiculo === null || veiculo === void 0 ? void 0 : veiculo.marca) || (veiculoSelecionado === null || veiculoSelecionado === void 0 ? void 0 : veiculoSelecionado.marca) })), _jsx("div", __assign({ style: {
                    border: "1px solid ".concat(Colors.VERMELHO_GOV),
                    borderRadius: "2rem",
                    padding: "0.2rem 0.75rem",
                    textAlign: "center",
                } }, { children: _jsxs(Typography, __assign({ variant: "body2", fontSize: "1rem", sx: { color: Colors.VERMELHO_GOV } }, { children: ["\u00DAltimo Licenciamento:", " ", (veiculo === null || veiculo === void 0 ? void 0 : veiculo.anoLicenciamento) || (veiculoSelecionado === null || veiculoSelecionado === void 0 ? void 0 : veiculoSelecionado.anoLicenciamento)] })) })), _jsxs(Box, __assign({ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap", gap: "0.25rem" }, { children: [_jsxs("div", __assign({ style: { flex: 1 } }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Placa" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: (veiculo === null || veiculo === void 0 ? void 0 : veiculo.placa) || (veiculoSelecionado === null || veiculoSelecionado === void 0 ? void 0 : veiculoSelecionado.placa) }))] })), _jsxs("div", __assign({ style: { flex: 1 } }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "RENAVAM" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: (veiculo === null || veiculo === void 0 ? void 0 : veiculo.renavam) || (veiculoSelecionado === null || veiculoSelecionado === void 0 ? void 0 : veiculoSelecionado.renavam) }))] })), _jsxs("div", __assign({ style: { flex: 1 } }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Chassi" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: (veiculo === null || veiculo === void 0 ? void 0 : veiculo.chassi) || (veiculoSelecionado === null || veiculoSelecionado === void 0 ? void 0 : veiculoSelecionado.chassi) }))] })), _jsxs("div", __assign({ style: { flex: 1 } }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Roubo ou Furto" })), _jsxs(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: [(veiculo === null || veiculo === void 0 ? void 0 : veiculo.rouboFurto) === "N" && "Não", (veiculo === null || veiculo === void 0 ? void 0 : veiculo.rouboFurto) === "S" && "Sim", veiculo === undefined &&
                                        (veiculoSelecionado === null || veiculoSelecionado === void 0 ? void 0 : veiculoSelecionado.rouboFurto) === "N" &&
                                        "Não", veiculo === undefined &&
                                        (veiculoSelecionado === null || veiculoSelecionado === void 0 ? void 0 : veiculoSelecionado.rouboFurto) === "S" &&
                                        "Sim"] }))] }))] }))] })));
};
